import { type SVGProps, type Ref, forwardRef, useId } from 'react'

import { cn } from '~/utils/classnames'

export const MediaManager = forwardRef(
  (
    { className, ...props }: SVGProps<SVGSVGElement>,
    ref: Ref<SVGSVGElement>
  ) => {
    const clip0 = useId()
    const filter0 = useId()
    const filter1 = useId()
    const filter2 = useId()
    const paint0 = useId()
    const paint1 = useId()
    const pattern0 = useId()

    return (
      <svg
        width="101"
        height="100"
        viewBox="0 0 101 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        ref={ref}
        className={cn('text-foreground', className)}
        {...props}
      >
        <path
          opacity="0.24"
          d="M100.5 79.001V21.001C100.5 16.5827 96.9183 13.001 92.5 13.001H50.5H8.5C4.08172 13.001 0.5 16.5827 0.5 21.001V79.001C0.5 83.4193 4.08172 87.001 8.5 87.001H50.5H92.5C96.9183 87.001 100.5 83.4193 100.5 79.001Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeDasharray="4 4"
        />
        <g clipPath={`url(#${clip0})`}>
          <g opacity="0.64">
            <g filter={`url(#${filter0})`}>
              <path
                d="M38.7548 41.7932C12.3752 41.7932 2.75974 10.8724 3.92057 0.811912L93.6444 -3.25098C102.544 4.8748 115.004 26.9305 93.6444 50.147C66.9455 79.1676 58.1169 41.7932 38.7548 41.7932Z"
                fill={`url(#${paint0})`}
              />
            </g>
            <g opacity="0.4" filter={`url(#${filter1})`}>
              <path
                d="M14.388 58.4745C4.23483 67.8723 -13.2006 50.7328 -20.6491 40.9884L22.4257 -7.52134C35.6119 -6.28753 62.8778 4.95258 66.4511 40.0426C70.9177 83.9051 27.0795 46.7271 14.388 58.4745Z"
                fill={`url(#${paint1})`}
              />
              <path
                d="M14.388 58.4745C4.23483 67.8723 -13.2006 50.7328 -20.6491 40.9884L22.4257 -7.52134C35.6119 -6.28753 62.8778 4.95258 66.4511 40.0426C70.9177 83.9051 27.0795 46.7271 14.388 58.4745Z"
                stroke="currentColor"
              />
            </g>
            <g opacity="0.3" filter={`url(#${filter2})`}>
              <path
                d="M83.415 85.1805C97.6227 82.2163 101.909 96.8386 102.276 104.52L36.7787 122.214C26.4486 118.103 10.34 104.455 28.5457 82.7529C51.3028 55.6253 65.6553 88.8859 83.415 85.1805Z"
                fill="currentColor"
              />
              <path
                d="M83.415 85.1805C97.6227 82.2163 101.909 96.8386 102.276 104.52L36.7787 122.214C26.4486 118.103 10.34 104.455 28.5457 82.7529C51.3028 55.6253 65.6553 88.8859 83.415 85.1805Z"
                stroke="currentColor"
              />
            </g>
          </g>
          <rect
            x="-284.793"
            y="-276.999"
            width="678"
            height="678"
            fill={`url(#${pattern0})`}
            style={{ mixBlendMode: 'soft-light' }}
          />
        </g>
        <defs>
          <filter
            id={filter0}
            x="-8.36097"
            y="-15.4396"
            width="125.988"
            height="88.8143"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="6.09433"
              result="effect1_foregroundBlur_2369_37969"
            />
          </filter>
          <filter
            id={filter1}
            x="-36.7237"
            y="-23.4494"
            width="119.396"
            height="101.45"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="7.66145"
              result="effect1_foregroundBlur_2369_37969"
            />
          </filter>
          <filter
            id={filter2}
            x="4.38762"
            y="56.1083"
            width="113.813"
            height="82.0389"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="7.66145"
              result="effect1_foregroundBlur_2369_37969"
            />
          </filter>
          <pattern
            id={pattern0}
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use xlinkHref={`#${pattern0}`} transform="scale(0.000488281)" />
          </pattern>
          <radialGradient
            id={paint0}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(76.051 57.8383) rotate(-134.594) scale(57.9968 147.483)"
          >
            <stop stopColor="currentColor" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0.44" />
          </radialGradient>
          <linearGradient
            id={paint1}
            x1="54.0263"
            y1="30.7502"
            x2="18.9178"
            y2="76.143"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.474545" stopColor="currentColor" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0" />
          </linearGradient>
          <clipPath id={clip0}>
            <rect
              x="13.5"
              y="0.000976562"
              width="74"
              height="100"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    )
  }
)

MediaManager.displayName = 'MediaManagerEmptyState'
